import React from 'react';
import {OrbitComponent} from '../../../../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';
import {GameInfo} from '../../../../../services/games/game-info';
import {StripeImageBox} from './boxes/stripe-image/stripe-image.box';

export interface GameImagePreviewComponentProps {
  gameInfo: GameInfo;
}

export const GameStripeImageComponent = observer(
    class GameStripeImageComponent extends OrbitComponent<GameImagePreviewComponentProps> {

        render() {
            let gameInfo = this.props.gameInfo;
            let imageSrc = gameInfo.stripImage ? gameInfo.stripImage : gameInfo.stripeImageFallback;
            // I noticed that sometimes react doesn't re render this component even if a different gameInfo is provided.
            // Setting key={gameInfo.gameType} seems to overcome this issue
            return (
                <StripeImageBox key={gameInfo.gameType} className='cy-game-strip-image' src={imageSrc} fallbackSrc={gameInfo.stripeImageFallback}/>
            );
        }
    }
);

